/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createConj } from '../../factoriesAny.js';
export var conjDependencies = {
  typedDependencies,
  createConj
};